import { useContext, useState } from "react"
import { AuthContext } from "../contexts/auth"
import toast from "react-hot-toast"
import { useNavigate  } from "react-router-dom"
import postService from "../services/postService"
import getServices from "../services/getServices"

const TemplatePermissaoState = () => {
    const navigate = useNavigate();
    const { signOut } = useContext(AuthContext)
    const [submit, setSubmit] = useState(false)
    const [template, setTemplate] = useState(null)
    const [nome, setNome] = useState('')    


    const [funcionarios, setFuncionarios] = useState([])  
    const [funcionariosSelecionados,  setFuncionariosSelecionados] = useState([])      
   
    const _getTemplate = async (id)=>{
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices(`admin/templateformulario/${id}/`)
        if (result.type === 'success'){
            setNome(result.data.tipotarefa.nome)
            setTemplate(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        else if (result.data?.detail === 'Não encontrado.'){
            toast.error(result.data?.detail)
            navigate('/gestor/template') 
        }
        setSubmit(false)
    }

    const _getPermissaoTemplate = async ()=>{
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices(`admin/usuariotarefas/${template.tipotarefa.id}/`)
        if (result.type === 'success'){
            setFuncionariosSelecionados(result.data.map(item=>{return {id:item.usuario.id, name: `${item?.usuario.nome} (${item?.usuario.company})`} }))
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    const _getFuncionarios = async ()=>{
        
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices(`admin/funcionario/`)
        if (result.type === 'success'){
            setFuncionarios(result.data.map(item=>{return {id:item.user_id, name: `${item.name} (${item?.company})`} }))            
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    const _permitirTemplate = async () =>{

        if (submit){
            return;
        }
        setSubmit(true)


        let jsons = []
        funcionariosSelecionados.forEach(item => {
        jsons.push({ usuario: item.id })
        })
        
        let result = await postService(`admin/usuariotarefas/${template.tipotarefa.id}/`, jsons)
        if (result.type === 'success'){
            toast.success('Permissões atualizadas com sucesso!')
            navigate('/gestor/template')
        }
            
        if (result.type === 'error'){
            toast.error(result.data.detail)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
         }
         setSubmit(false)
        return 
    }
    return {
        
        template:{value:template,set:_getTemplate}, 
        nome:{value:nome,set:setNome}, 
        submit: {value: submit, set: _permitirTemplate},

        funcionarios: {value: funcionarios, set: _getFuncionarios},     
        funcionariosSelecionados: {value: funcionariosSelecionados, set: setFuncionariosSelecionados},  

        buscarPermissaoCurso: {value: ()=>{console.log('não implementado')}, set: _getPermissaoTemplate},
    }
}

export default TemplatePermissaoState